<template>
  <b-container fluid>
    <b-card>
      <b-overlay>
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col
                  cols="12"
                  class="text-right"
              >
                <b-button-group>
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      v-b-modal.certificateProcessTypeSaveModal
                      class=""
                      variant="success"
                      @click="createCredentialProcessType"
                  >
                    <feather-icon icon="PlusIcon" />
                    Thêm mới
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-overlay>

      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-0">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ filter.itemsPerPage * (filter.currentPage) }} của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                    mode="remote"
                    class="my-table"
                    row-style-class="vgt-row"
                    style-class="vgt-table striped bordered"
                    :columns="columns"
                    :rows="certificateProcessTypes"
                    :line-numbers="true"
                    :total-rows="totalRows"
                    :pagination-options="paginationOptions"
                    @on-page-change="onPageChange"
                    @on-per-page-change="onPerPageChange"
                >
                  <div
                      slot="emptystate"
                      style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>

                  <template
                      slot="table-row"
                      slot-scope="props"
                  >
                    <span v-if="props.column.field === 'status'">
                      {{ getStatusName(props.row.status) }}
                    </span>
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                    <span
                        v-if="props.column.field === 'action'"
                        class="thead-group-action"
                    >
                      <b-button-group>
                        <b-button
                            class="btn-icon"
                            v-b-modal.certificateProcessTypeSaveModal
                            variant="primary"
                            size="sm"
                            @click="onUpdateCertificateProcessType(props.row)"
                        >
                          <feather-icon icon="Edit2Icon" />
                        </b-button>

                        <b-button
                            class="btn-icon"
                            variant="danger"
                            size="sm"
                            @click="onDeleteCertificateProcessType(props.row)"
                        >
                          <feather-icon icon="TrashIcon" />
                        </b-button>

                      </b-button-group>
                    </span>
                  </template>
                  <!-- pagination -->
                  <template
                      slot="pagination-bottom"
                      slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                            v-model="filter.itemsPerPage"
                            :options="itemsPerPageOptions"
                            class="mx-1"
                            @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                            :value="1"
                            :total-rows="totalRows"
                            :per-page="filter.itemsPerPage"
                            class="mt-1 mb-0"
                            @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <CertificateProcessTypeSave
        ref="certificateProcessTypeSaveModal"
        :item="currentCertificateProcessType"
        @succeed="onSucceed"
    />
  </b-container>
</template>
<script>

import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormGroup, BFormSelect, BOverlay, BPagination, BRow,
  VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import '@core/scss/vue/libs/vue-good-table.scss'
import { getUser } from '@/auth/utils'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CertificateProcessTypeSave from '@/views/certificate/certificate-process-types/CertificateProcessTypesSave.vue'

export default {
  name: 'CertificateProcessType',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    CertificateProcessTypeSave,
    BDropdown,
    BDropdownItem,
    VueGoodTable,
    BButton,
    BButtonGroup,
    BCard,
    BCol,
    BContainer,
    BFormGroup,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
      },
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      currentCertificateProcessType: undefined,
      columns: [
        {
          label: 'Tên',
          field: 'name',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-left',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
        },
        {
          label: 'Mã',
          field: 'code',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-left',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
        },
        {
          label: 'Trạng thái',
          field: 'status',
          sortable: true,
          filterOptions: {
            placeholder: 'Tất cả',
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: this.statusFilterDropdownItems,
          },
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          sortable: false,
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      statuses: 'certificateProcessType/statuses',
      certificateProcessTypes: 'certificateProcessType/certificateProcessTypes',
      totalRows: 'certificateProcessType/totalRows',
    }),
    statusFilterDropdownItems() {
      return this.statuses.map(status => ({
        value: status.value,
        text: status.label,
      }))
    },
  },
  async created() {
    this.isLoading = true
    try {
      await this.readCertificateProcessTypes(this.filter)
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      readCertificateProcessTypes: 'certificateProcessType/readCertificateProcessTypes',
      deleteCertificateProcessType: 'certificateProcessType/deleteCertificateProcessType',

    }),
    createCredentialProcessType() {
      this.currentCertificateProcessType = undefined
    },
    getStatusName(id) {
      return this.statuses.find(status => status.value === id).label
    },
    onUpdateCertificateProcessType(row) {
      const {
        originalIndex,
        vgt_id,
        ...rest
      } = row
      this.currentCertificateProcessType = rest
    },
    onDeleteCertificateProcessType(certificateProcessType) {
      this.$swal({
        title: 'Bạn có chắc chắn muốn xóa?',
        text: `Xóa thời gian ${certificateProcessType.name}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          const response = await this.deleteCertificateProcessType(certificateProcessType.id)
          const { isSuccessful, message } = response
          if (response) {
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              try {
                await this.readCertificateProcessTypes(this.filter)
              } catch (e) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `[${e.code}] ${e.message}`,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
          try {
            await this.deleteCertificateProcessType(certificateProcessType.id)
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
      this.isLoading = false
    },
    async getDataFromStore() {
      this.isLoading = true
      try {
        await this.readCertificateProcessTypes(this.filter)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onSucceed() {
      await this.getDataFromStore()
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getCredentialsFromStore()
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getCredentialsFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        const selectedColumn = this.columns.findIndex(e => e.field === field)

        this.updateParams({ sort: `${selectedColumn}_${type}` })
      }
      await this.getProgrammesFromStore()
    },
  },
}
</script>
<style scoped lang="scss">
</style>
